
export class AlarmaModel {
    uuid: string;
    nombre: string;
    descripcion: string;
    disabled: string;
    deleted: string;
    alarmado: string;
    alarmadoDate: string;
    disabledDate: string;
    tipo: TipoAlarmaModel;
    parametros: ParametrosAlarmaModel[];
    depende: DatoModel[];
    informaConnection: {
        edges: EdgeModel[];
    };
    usuario: string;
    timeout: number;
}

export class ParametrosAlarmaModel {
    uuid: string;
    clave: string;
    valor: string;
}

export class DatoModel {
    variable: string;
    uuid: string;
    es: {
        nombre: string;
        descripcion: string
    };
    tiene: {
        nombre: string;
    }
    descripcion: null
}

export class VariablesModel {
    variable: string;
    DatoModel;
}

export class EdgeModel {
    node: NodeModel;
    uuid: string;
    alarmado: string;
    disabled: string;
    
}

export class NodeModel {
    uuid: string;
    nombre: string;
    apellidos: string;
    usuario: string;
    mail: string;
    enabled: string
}

export class InformaModel {
    uuid: string;
    alarmado: string;
    disabled: string;
    node: UsuarioModel

}

export class UsuarioModel {
    uuid: string;
    nombre: string;
    apellidos: string;
    usuario: string;
}

export class TipoAlarmaModel {
    uuid: string;
    codigo: string;
    formula: string;
    nombre: string;
    nombreCode: string;
    subject_es: string;
    subject_en: string;
    body_es: string;
    body_en: string;
    fields: string;
}

export class FieldModel {
    clave: string;
    descripcion: string;
    tipo: string;
}

export class NewDependeModel {
    idFormControl: string;
    uuidAlarma: string;
    variable: string;
    dato: string;
}

export class NewParametroModel {
    idFormControl: string;
    uuidAlarma: string;
    clave: string;
    valor: string;
}

export class UpdateParametroModel {
    idFormControl: string;
    uuid: string;
    uuidAlarma: string;
    clave: string;
    valor: string;
}

export class NewInformaModel {
    uuidAlarma: string;
    uuidUsuario: string;
}

export class AlarmaEvento {
    dateCreated: Date
    dateValues: string
    valuesNano: string;
    formula: string
    alarmaUUID: string;
    tipoEvento: string;
}

